import type { CreatorLabPageViewSource } from '@app/routes/content/analytics/events';

import { BLACK } from './theme/theme-colors';

export const CLIPS_COLORS = [
  '#00E0FF', // cyan
  '#FF4930', // red
  '#C54DFD', // purple
  '#FF1DF6', // pink
  '#FF2480', // magenta
  '#FF8E3C', // orange
  '#FFE600', // yellow
  '#5CF100', // green
  '#05FFD2', // teal
  '#1F85FE', // blue
] as const;

// Default colors - matches tailwind.config.js colors.primary
// Color order from presets:
// 1st (BRAND-PRIMARY / colorPrimary400) → active word color
// 2nd (NEUTRAL-PRIMARY / colorWhite) → video player background
// Caption text color is always white with black outline (not from preset)
export const DEFAULT_ACTIVE_WORD_COLOR = '#1d6eaa';
export const DEFAULT_VIDEO_BG_COLOR = BLACK;
export const DEFAULT_CAPTIONS_POSITION = 'bottom';

export const HOPIN_WEB_SOURCES = new Set<CreatorLabPageViewSource>([
  'event-dashboard-recording-page',
  'event-dashboard-email-page',
]);

export const HOPIN_WEB_DOMAINS = new Set([
  'events.ringcentral.com',
  'staging.events.ringcentral.com',
]);

export const SOURCE_TO_EVENT: Partial<
  Record<
    CreatorLabPageViewSource,
    | 'RecordingCard_EditAndShare_Clicked'
    | 'Event_dashboard_emails_banner_cta_clicked'
  >
> = {
  'event-dashboard-recording-page': 'RecordingCard_EditAndShare_Clicked',
  'event-dashboard-email-page': 'Event_dashboard_emails_banner_cta_clicked',
};
